import { render } from "./ManageCampaigns.vue?vue&type=template&id=dca4fe82&scoped=true"
import script from "./ManageCampaigns.vue?vue&type=script&lang=js"
export * from "./ManageCampaigns.vue?vue&type=script&lang=js"

import "./ManageCampaigns.vue?vue&type=style&index=0&id=dca4fe82&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dca4fe82"]])

export default __exports__